import { Button, Table, Tag, Tooltip } from "antd";
import React, { Fragment, useState } from "react";
import { TimesheetActionButtonCol } from "../TimesheetActionButtonCol/TimesheetActionButtonCol";
import { formatDate, formatDateWithDay } from "../../../../shared/helpers";
import VectorIcon from "../../../../assets/icons/Vector.svg";
import { useSelector } from "react-redux";
import {
  TIME_SHEET_PENDING_ACTION,
} from "../../TimeSheetConstants";
import { FileTextOutlined } from "@ant-design/icons";
import { useWindowDimensions } from "../../../../hooks/useDimensionHook";

const TimeOffTable = ({ handleApproveRejectClick, handleShowReason }) => {
  const { width } = useWindowDimensions();
  const timeOffData = useSelector(
    (state) => state.TimeOffReducer.data?.data || []
  );

  const columns = [
    {
      title: "From",
      key: "from",
      render: (_, record) => {
        return <span>{formatDateWithDay(record?.fromDate)}</span>;
      },
    },
    {
      title: "To",
      key: "to",
      editable: true,
      render: (_, record) => {
        return <span>{formatDateWithDay(record?.toDate)}</span>;
      },
    },
    {
      title: "Days",
      key: "days",
      render: (_, record) => {
        return record?.days;
      },
    },
    {
      title: "Time Off Type",
      key: "timeOffType",
      width: "18%",
      render: (_, record) => {
        return record?.type || "N/A";
      },
    },
    {
      title: "Time Off Reason",
      key: "action",
      width: "18%",
      render: (_, record) => {
        return (
          <Button
            style={{
              border: "transparent !important",
              background: "transparent !important",
            }}
            onClick={() => handleShowReason(record)}
            disabled={record?.status !== TIME_SHEET_PENDING_ACTION}
            type="ghost"
            icon={
              <FileTextOutlined
                style={{ color: "#888888", cursor: "pointer" }}
              />
            }
          />
        );
      },
    },
    {
      title: "Approval",
      key: "action",
      width: width < 900 ? "25%" : "20%",
      render: (_, record) => {
        return (
          <TimesheetActionButtonCol
            status={record?.status}
            handleApprove={() => handleApproveRejectClick(record)}
            handleReject={() => handleApproveRejectClick(record)}
          />
        );
      },
    },
    {
      title: "Reason",
      key: "reason",
      width: "5%",
      render: (_, data) => {
        const record = data;
        const title =
          record?.status == "approved" ? (
            <>
              Approved (on {formatDateWithDay(record?.actionDate)}) by
              <br />
              {record?.actionBy}
            </>
          ) : (
            <>
              Rejected (on {formatDateWithDay(record?.actionDate)}) by
              <br />
              {record?.actionBy}:
              <br />
              {record?.rejectionReason}
            </>
          );

        return record?.status == "pending" ? "N/A" : (
          <Tooltip title={title}>
            <img src={VectorIcon} alt="?-icon" />
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Fragment>
      <Table dataSource={timeOffData} columns={columns} />
    </Fragment>
  );
};

export { TimeOffTable };
